import classNames from 'classnames';
import copy from 'clipboard-copy';
import { useEffect, useRef, useState } from 'react';

import ProShareButton from '../buttons/ProShareButton';
import TextField from './TextField';

import styles from '../../styles/fields/share-url-field.module.css';

export interface ShareUrlFieldProps {
    value?: string | null;
    className?: string | null;
    inputClassName?: string | null;
    [key: string]: unknown;
}

function ShareUrlField({
    value,
    className = null,
    inputClassName = null,
    ...props
}: ShareUrlFieldProps) {
    const inputRef = useRef<HTMLInputElement>(null);
    const [focused, setFocused] = useState(false);
    const onFocus = () => {
        setFocused(true);
        inputRef.current?.select();
    };
    const onBlur = () => setFocused(false);

    const [copied, setCopied] = useState(false);
    const onClickCopy = () => {
        copy(value);
        setCopied(true);
    };

    useEffect(() => {
        let timeout = null;
        if (copied !== null) {
            timeout = setTimeout(() => {
                setCopied(false);
            }, 2000);
        }
        return () => {
            if (timeout !== null) {
                clearTimeout(timeout);
            }
        };
    }, [copied]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.focused]: focused || copied,
                },
                className,
            ])}
        >
            <div className={styles.field}>
                <ProShareButton className={styles.button} onClick={onClickCopy} />
                <TextField
                    value={value}
                    className={classNames([styles.input, inputClassName])}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onClick={onClickCopy}
                    ref={inputRef}
                    {...props}
                />
            </div>
            {copied ? <div className={styles.tooltip}>Lien copié!</div> : null}
        </div>
    );
}

export default ShareUrlField;
